/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Unlockaccess_Emailcolumnheader4Inputs */

const en_coinvestments_outreach_unlockaccess_emailcolumnheader4 = /** @type {(inputs: Coinvestments_Outreach_Unlockaccess_Emailcolumnheader4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Coinvestments_Outreach_Unlockaccess_Emailcolumnheader4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_unlockaccess_emailcolumnheader4 = /** @type {((inputs?: Coinvestments_Outreach_Unlockaccess_Emailcolumnheader4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Unlockaccess_Emailcolumnheader4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_unlockaccess_emailcolumnheader4(inputs)
});
export { coinvestments_outreach_unlockaccess_emailcolumnheader4 as "coInvestments_outreach_unlockAccess_emailColumnHeader" }